(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["zoomie-faq"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    const tab = event.target.closest('[data-zoomie-faq-tab]');
    if (tab) {
      const root = tab.closest('[data-zoomie-faq]');
      const target = tab.dataset.zoomieFaqTab;

      root.querySelectorAll('[data-zoomie-faq-tab]').forEach((button) => {
        const isActive = button === tab;
        button.classList.toggle('zoomie-faq__tab--active', isActive);
        button.setAttribute('aria-selected', String(isActive));
      });

      root.querySelectorAll('[data-zoomie-faq-panel]').forEach((panel) => {
        const isActive = panel.dataset.zoomieFaqPanel === target;
        panel.hidden = !isActive;
        panel.classList.toggle('zoomie-faq__panel--active', isActive);
        panel.querySelectorAll('details').forEach((item) => item.removeAttribute('open'));
      });

      const moreButton = root.querySelector('[data-zoomie-faq-more]');
      if (moreButton) {
        const activePanel = root.querySelector(`[data-zoomie-faq-panel="${target}"]`);
        const hiddenItems = activePanel.querySelectorAll('[data-zoomie-faq-extra][hidden]');
        moreButton.hidden = hiddenItems.length === 0;
      }
      return;
    }

    const moreButton = event.target.closest('[data-zoomie-faq-more]');
    if (!moreButton) return;

    const root = moreButton.closest('[data-zoomie-faq]');
    const activePanel = root.querySelector('.zoomie-faq__panel--active');
    activePanel.querySelectorAll('[data-zoomie-faq-extra]').forEach((item) => {
      item.hidden = false;
    });
    moreButton.hidden = true;
  });
  } catch(e) { console.error(e); }
})();

})();
